import React, { useEffect, useState } from "react";
import "./back.scss";

const Back = () => {
    const [showBack, setShowBack] = useState(false); // State to control Back component visibility

    useEffect(() => {
        const handleScroll = () => {
            // Toggle visibility of Back component
            if (window.scrollY > 200) {
                setShowBack(true);
            } else {
                setShowBack(false);
            }
        };

        // Attach scroll event listener
        window.addEventListener("scroll", handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <a 
        aria-label="Back to top"
        href="#" 
        className= {`back ${showBack ? 'fadeInUp' : ''}`} 
        onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" })
        }}
        >
            <span className="material-symbols-outlined">
                arrow_upward
            </span>
        </a>
    );
};

export default Back;
